import { render } from "./ModalEditarRelacion.vue?vue&type=template&id=75a4ae70&scoped=true"
import script from "./ModalEditarRelacion.vue?vue&type=script&lang=js"
export * from "./ModalEditarRelacion.vue?vue&type=script&lang=js"

import "./ModalEditarRelacion.vue?vue&type=style&index=0&id=75a4ae70&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75a4ae70"]])

export default __exports__